// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3b9Qg","col":"styles_col__2mJXT"};